import { cn } from '@/lib/utils';

interface SkeletonProps {
    className?: string;
    circle?: boolean;
}

const Skeleton = ({ className, circle = false }: SkeletonProps) => (
    <span
        aria-hidden="true"
        className={cn('block animate-pulse bg-bg-grey-100', circle ? 'rounded-full' : 'rounded-[8px]', className)}
    />
);

export default Skeleton;
